var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finalExamResult !== null)?_c('a',{staticClass:"button green m-auto text-decoration-none",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onButtonClicked}},[_c('span',[_vm._v(" "+_vm._s(_vm.buttonCaption)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }